var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('UserCreateTweet',{on:{"after-show-tweet-modal":_vm.afterShowModal}}),_c('TweetCards',{on:{"after-show-reply-modal":_vm.afterShowReplyModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }